<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-trash heroicon heroicon-sm"
  >
    <path
      class="heroicon-trash-can heroicon-component-fill"
      fill="#FFFFFF"
      d="M7 13h46v41a5 5 0 0 1-5 5H12a5 5 0 0 1-5-5V13z"
    ></path>
    <path
      class="heroicon-trash-lid heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M22 7V4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3h14a2 2 0 0 1 2 2v4H6V9c0-1.1.9-2 2-2h14zm3 0h10V4a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v3z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M7 13h46v2H7v-2zm6 3.27A2 2 0 0 0 12 18v36a2 2 0 0 0 1 1.73A2 2 0 0 1 10 54V18a2 2 0 0 1 3-1.73zm9 0A2 2 0 0 0 21 18v36a2 2 0 0 0 1 1.73A2 2 0 0 1 19 54V18a2 2 0 0 1 3-1.73zm9 0A2 2 0 0 0 30 18v36a2 2 0 0 0 1 1.73A2 2 0 0 1 28 54V18a2 2 0 0 1 3-1.73zm9 0A2 2 0 0 0 39 18v36a2 2 0 0 0 1 1.73A2 2 0 0 1 37 54V18a2 2 0 0 1 3-1.73zm9 0A2 2 0 0 0 48 18v36a2 2 0 0 0 1 1.73A2 2 0 0 1 46 54V18a2 2 0 0 1 3-1.73z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      d="M5 9a3 3 0 0 1 3-3h14V4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2h14a3 3 0 0 1 3 3v3a1 1 0 1 1 0 2h-1v40a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V14H5a1 1 0 1 1 0-2V9zm31-3h1V4a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v2h1V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v2zM25 8H8a1 1 0 0 0-1 1v3h46V9a1 1 0 0 0-1-1H25zM8 54a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4V14H8v40zM25 6h10V4a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v2zm7 4v1H8v-1h24zm-22 8a2 2 0 1 1 4 0v36a2 2 0 1 1-4 0V18zm3 0a1 1 0 1 0-2 0v36a1 1 0 1 0 2 0V18zm35-2a2 2 0 0 1 2 2v36a2 2 0 1 1-4 0V18c0-1.1.9-2 2-2zm1 38V18a1 1 0 1 0-2 0v36a1 1 0 1 0 2 0zM28 18a2 2 0 1 1 4 0v36a2 2 0 1 1-4 0V18zm3 0a1 1 0 1 0-2 0v36a1 1 0 1 0 2 0V18zm-10-2a2 2 0 0 1 2 2v36a2 2 0 1 1-4 0V18c0-1.1.9-2 2-2zm1 38V18a1 1 0 1 0-2 0v36a1 1 0 1 0 2 0zm15-36a2 2 0 1 1 4 0v36a2 2 0 1 1-4 0V18zm3 0a1 1 0 1 0-2 0v36a1 1 0 1 0 2 0V18z"
    ></path>
  </svg>
</template>
